/**
 * Formats an elapsed meeting duration as a zero-padded `HH:mm:ss` clock — the
 * timer shown while a meeting is recording.
 *
 * Deliberately separate from {@link formatElapsedTime}, which takes
 * MILLISECONDS and prints `mm:ss` for transcript timestamps. The two units are
 * close enough to be confused, and both were previously duplicated at their
 * call sites, so the parameter name and the `Hms` suffix carry the difference.
 *
 * @param seconds Seconds elapsed since the meeting started.
 * @returns A zero-padded `HH:mm:ss` label.
 */
export function formatElapsedHms(seconds: number): string {
  // UTC is deliberate: the input is a duration, not an instant, so only the
  // offset from the epoch matters and `slice(11, 19)` lifts the clock straight
  // out of the ISO string without a handful of divisions.
  return new Date(seconds * 1000).toISOString().slice(11, 19)
}
